import { UNITS } from "../../constants/units.constant";

export const CHEMICAL_VALUE_MAX_FRACTIONS = 4;
export const CHEMICAL_PRICE_MAX_FRACTIONS = 3;
export const CHEMICAL_PRICE_RANGE = {
  min: 0.01,
  max: 1000,
};
export const CHEMICAL_UNIT_TYPES = [UNITS.pound, UNITS.kiloGram];

export const CHEMICAL_FIELDS = {
  id: "id",
  chemId: "chem_id",
  chemical: "chemical",
  symbol: "symbol",
  category: "category",
  displayName: "display_name",
  bulkConcentration: "bulk_concentration",
  bulkDensity: "bulk_density",
  price: "price",
  currency: "currency",
  unit: "unit",
  updatedAt: "updated_at",
  isCustom: "is_custom",
};

export const CHEMICAL_UNIT_DROPDOWN_OPTIONS = [
  { label: UNITS.pound, value: UNITS.pound },
  { label: UNITS.kiloGram, value: UNITS.kiloGram },
];
